<app-navbar></app-navbar>
<section class="focus">
  <div class="flex-container">
    <div class="flex-row flex-justify-center">
      <div class="flex-col-4 flex-col-md-6 flex-col-sm-12">
        <div class="login-form">
          <h1 class="ds-title-1">{{ 'reset_pass.title' | translate }}</h1>
          <form [formGroup]="resetForm" #resetFormEl="ngForm" (ngSubmit)="setPassword()">
            <div>
              <div class="ds-form-row" [ngClass]="{ 'has-error': resetFormEl.submitted && isPasswordInvalid }">
                <label class="ds-ui-2" for="password">{{ 'no_survey.user.new_pass' | translate }}</label>
                <div class="input-wrapper">
                  <input
                    class="ds-input"
                    [ngClass]="{ touched: passwordControl.value }"
                    (input)="hidePasswordHints = false"
                    [type]="showPass['newPassword'] ? 'text' : 'password'"
                    minlength="12"
                    maxlength="128"
                    type="password"
                    formControlName="password"
                    [placeholder]="'placeholder.password' | translate"
                    [ngClass]="{ 'is-invalid': resetFormEl.submitted && isPasswordInvalid }"
                    id="track_pass_input"
                    data-cy="input-password"
                    required
                  />
                  <app-ds-icon
                    (click)="passVisibility('newPassword')"
                    class="visibility"
                    [name]="showPass['newPassword'] ? 'eye-off' : 'eye'"
                    color="var(--color-core-neutral-7)"
                    size="icon-size-2"
                  ></app-ds-icon>
                </div>
                <app-register-password-strength
                  class="password-hints"
                  [dirty]="passwordControl.dirty"
                  [password]="passwordControl.value"
                  [submitted]="resetFormEl.submitted"
                  (isPasswordInvalid)="onIsPasswordInvalid($event)"
                  *ngIf="(resetFormEl.submitted && isPasswordInvalid) || !hidePasswordHints"
                >
                </app-register-password-strength>
              </div>
            </div>
            <div
              class="ds-form-row repeat-password"
              [ngClass]="{ 'has-error': resetFormEl.submitted && (!passwordMatch || confirmPasswordControl.value.length === 0) }"
            >
              <label class="ds-ui-2" for="repeatPassword">{{ 'reset_pass.repeat_password' | translate }}</label>
              <div class="input-wrapper">
                <input
                  class="ds-input"
                  [ngClass]="{ touched: confirmPasswordControl.value }"
                  [type]="showPass['confirmPassword'] ? 'text' : 'password'"
                  minlength="12"
                  maxlength="128"
                  type="password"
                  formControlName="repeatPassword"
                  (keyup)="passwordChange()"
                  [placeholder]="'placeholder.password' | translate"
                  [ngClass]="{ 'is-invalid': resetFormEl.submitted && !passwordMatch }"
                  data-cy="input-password"
                  required
                />
                <app-ds-icon
                  (click)="passVisibility('confirmPassword')"
                  class="visibility"
                  [name]="showPass['confirmPassword'] ? 'eye-off' : 'eye'"
                  color="var(--color-core-neutral-7)"
                  size="icon-size-2"
                ></app-ds-icon>
              </div>
              <div *ngIf="resetFormEl.submitted && confirmPasswordControl.value.length === 0" class="ds-input-error">
                <div>{{ 'reset_pass.password_error' | translate }}</div>
              </div>
              <div *ngIf="resetFormEl.submitted && !passwordMatch" class="ds-input-error">
                <div>{{ 'reset_pass.password_problem' | translate }}</div>
              </div>
            </div>
            <app-ds-callout
              *ngIf="resetFormEl.submitted && serverError"
              variant="critical"
              [description]="'reset_pass.token_problem' | translate: { link: '/reset-password' }"
            ></app-ds-callout>

            <app-ds-button variant="primary" width="auto" [isLoading]="loading" type="submit">
              {{ 'reset_pass.cta' | translate }}
            </app-ds-button>
          </form>
          <app-swiss-made-footer></app-swiss-made-footer>
        </div>
      </div>
    </div>
  </div>
</section>
